import { render } from "./EamilVerification.vue?vue&type=template&id=10a5f2d4&scoped=true"
import script from "./EamilVerification.vue?vue&type=script&lang=js"
export * from "./EamilVerification.vue?vue&type=script&lang=js"

import "./EamilVerification.vue?vue&type=style&index=0&id=10a5f2d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a5f2d4"]])

export default __exports__